// Documentação das integrações: o que o PULSE envia/consome em cada tipo e o
// passo a passo do lado de fora. Fonte única — a seção de documentação da
// tela E o painel lateral do modal leem daqui.
//
// O conteúdo descreve o CONTRATO REAL do disparo em
// backend/src/services/WbotServices/wbotMessageListener.ts (tipos n8n e
// webhook) e dos listeners de Typebot/SGP. Mudou o payload lá, muda aqui.
const n8nCamposLines = [
  'event: sempre "message"',
  "ticketId: ID do ticket no PULSE",
  'ticketStatus: status do ticket ("pending", "open"...)',
  "contactId: ID do contato no PULSE",
  "contactName: nome do contato",
  'contactNumber: número do contato (ex.: "558599999999")',
  "messageBody: texto da mensagem recebida",
  'messageType: tipo da mensagem ("conversation", "imageMessage", "audioMessage"...)',
  "fromMe: false para mensagem enviada pelo cliente",
  "timestamp: data/hora da mensagem (Unix timestamp, em segundos)",
  "companyId: ID da sua empresa no PULSE",
  "queueIntegrationId: ID da integração (coluna ID desta tela)",
];

const n8nPayloadExemplo = [
  "POST https://seu-n8n.exemplo.com/webhook/pulse",
  "Content-Type: application/json",
  "",
  "{",
  '  "event": "message",',
  '  "ticketId": 321,',
  '  "ticketStatus": "pending",',
  '  "contactId": 99,',
  '  "contactName": "Maria Silva",',
  '  "contactNumber": "558599999999",',
  '  "messageBody": "Olá, preciso de ajuda",',
  '  "messageType": "conversation",',
  '  "fromMe": false,',
  '  "timestamp": 1755400000,',
  '  "companyId": 1,',
  '  "queueIntegrationId": 2',
  "}",
].join("\n");

const n8nPassoAPasso = [
  '1. No n8n, crie um workflow e adicione o nó "Webhook".',
  '2. No nó, configure HTTP Method: POST e Respond: "Immediately".',
  "3. Copie a Production URL do nó (a Test URL só recebe em modo de teste).",
  "4. No PULSE, cadastre/edite a integração do tipo n8n nesta tela e cole",
  '   a URL no campo "URL do N8N".',
  "5. Vincule a integração à conexão ou à fila desejada.",
  "6. Ative o workflow no n8n. Pronto: cada mensagem recebida dispara o POST.",
  "",
  "# Observações",
  "# - O envio é um POST JSON com timeout de 10 segundos.",
  "# - Se o webhook responder 404 ao POST, o PULSE tenta um GET de fallback",
  "#   com ticketId, contactNumber, contactName, messageBody e companyId na",
  "#   query string — mas o correto é manter o nó configurado como POST.",
  "# - A resposta do webhook não é enviada ao cliente automaticamente: para",
  "#   responder a conversa, use no fluxo do n8n a API de envio do PULSE",
  "#   (tela “Uso da API”, rota /messages-api).",
].join("\n");

const typebotCamposLines = [
  "Nome: identificação da integração nesta tela",
  'URL da API do Typebot: endereço do servidor do seu Typebot, sem barra no final (ex.: "https://typebot.io")',
  "Typebot - Slug: ID público do fluxo publicado (o slug da URL de publicação)",
  "Expira em (minutos): tempo de inatividade para a conversa expirar e o fluxo recomeçar do início (0 = nunca expira)",
  "Delay padrão (ms): pausa entre as mensagens que o bot envia em sequência",
  "Palavra de finalização: quando o cliente envia essa palavra, o ticket é encerrado",
  "Palavra de reinício: reinicia o fluxo do zero",
  "Mensagem de reinício: enviada ao cliente quando o fluxo reinicia",
  "Mensagem desconhecida: enviada quando o bot recebe conteúdo que não entende",
];

const typebotChamadas = [
  "# O PULSE atua como cliente da API do seu Typebot (não é webhook):",
  "# a primeira mensagem abre a sessão e as seguintes continuam a conversa.",
  "POST {URL do Typebot}/api/v1/typebots/{slug}/startChat",
  "POST {URL do Typebot}/api/v1/sessions/{sessionId}/continueChat",
  "",
  "# No startChat vão variáveis pré-preenchidas — crie variáveis com estes",
  "# nomes no seu fluxo para usá-las:",
  "{",
  '  "prefilledVariables": {',
  '    "number": "558599999999",',
  '    "pushName": "Maria Silva",',
  '    "remoteJid": "558599999999@s.whatsapp.net"',
  "  }",
  "}",
].join("\n");

const typebotPassoAPasso = [
  '1. Crie o fluxo no Typebot e publique ("Publish").',
  "2. Copie o ID público do bot (slug que aparece na URL de publicação).",
  "3. No PULSE, cadastre a integração do tipo Typebot: cole a URL do",
  "   servidor e o slug do bot.",
  "4. Defina expiração, delay, palavras de finalização/reinício e as",
  "   mensagens de reinício e de conteúdo desconhecido.",
  "5. Vincule a integração à conexão ou à fila desejada.",
  "",
  "# Observações",
  "# - Blocos de texto, imagem, vídeo e áudio do fluxo são convertidos em",
  "#   mensagens do WhatsApp; links de texto rico viram [texto](url).",
  "# - Conteúdo que o PULSE não suporta dispara a “mensagem desconhecida”.",
  "# - A palavra de finalização encerra o ticket; a de reinício zera a",
  "#   sessão e envia a mensagem de reinício.",
].join("\n");

const dialogflowCamposLines = [
  "Nome: identificação da integração nesta tela",
  "Projeto Name: ID do projeto no Google Cloud onde o agente foi criado",
  'Linguagem: idioma do agente ("pt-BR", "en" ou "es")',
  "JsonContent: conteúdo completo da chave JSON da conta de serviço do Google Cloud",
];

const dialogflowPassoAPasso = [
  "1. Crie um agente no Dialogflow ES vinculado a um projeto do Google Cloud.",
  "2. No Google Cloud, ative a API do Dialogflow para esse projeto.",
  '3. Crie uma conta de serviço com o papel "Cliente da API Dialogflow"',
  "   e gere uma chave no formato JSON.",
  "4. Abra o arquivo JSON baixado e cole o conteúdo inteiro no campo",
  "   JsonContent da integração.",
  "5. Informe o ID do projeto, escolha o idioma e salve.",
  "6. Vincule a integração à conexão ou à fila desejada.",
  "",
  "# Observações",
  "# - Cada mensagem do cliente vira uma detecção de intenção (detectIntent)",
  "#   e as respostas do agente voltam para a conversa no WhatsApp.",
  "# - Mensagens de voz também são encaminhadas ao agente (detecção por áudio).",
].join("\n");

const flowbuilderComoFunciona = [
  "# Integração interna: não há sistema externo para configurar.",
  "",
  '1. Crie o fluxo na tela "Flowbuilder" do PULSE (menu lateral).',
  "2. Nesta tela, cadastre uma integração do tipo Flowbuilder (só o nome).",
  "3. Vincule a integração à conexão ou à fila desejada.",
  "4. Quando uma mensagem chega em um ticket sem atendente, o fluxo inicia",
  "   automaticamente.",
  "",
  "# Observações",
  "# - Toda a lógica (menus, condições, mensagens, mídia) mora no editor do",
  "#   Flowbuilder; esta integração é só o vínculo com a conexão/fila.",
].join("\n");

const sgpCamposLines = [
  "Nome: identificação da integração nesta tela",
  'SGP URL: endereço do seu SGP (ex.: "https://provedor.sgp.net.br")',
  'Usuário Informa Senha: "Sim" exige a senha da central do assinante além do CPF/CNPJ; "Não" autentica só com o CPF/CNPJ',
  "Widepay Token: token da sua conta Widepay (opcional; preencha apenas se a sua operação o utiliza)",
];

const sgpComoFunciona = [
  "# Autoatendimento para provedores que usam o SGP.",
  "",
  "1. O cliente informa o CPF/CNPJ (e a senha da central, se exigida).",
  "2. O PULSE consulta os contratos do assinante na API central do SGP.",
  "3. Conforme a operação definida na FILA vinculada — SB (segunda via de",
  "   fatura) ou LC (liberação em confiança) — o bot devolve a fatura ou",
  "   efetua a liberação do contrato.",
  "",
  "# Endpoints do SGP consumidos (na sua instalação):",
  "POST {SGP URL}/api/central/contratos",
  "POST {SGP URL}/api/central/fatura2via",
  "POST {SGP URL}/api/central/promessapagamento",
  "",
  "# Observações",
  "# - A autenticação é a da central do assinante: CPF/CNPJ + senha; quando",
  '#   "Usuário Informa Senha" está em "Não", o próprio CPF/CNPJ é usado',
  "#   como senha (comportamento padrão da central do SGP).",
].join("\n");

// Uma entrada por tipo de integração disponível no modal desta tela.
// Cada aba é "campos" (lista chave: descrição) ou "code" (texto pré-formatado
// em que linhas iniciadas por # saem apagadas, como na /messages-api).
export const INTEGRATION_DOCS = [
  {
    id: "n8n",
    label: "n8n / Webhook",
    method: "POST",
    endpoint: "URL do N8N cadastrada na integração",
    intro:
      "Para integrações do tipo n8n (ou webhook), o PULSE dispara um POST " +
      "para a URL configurada sempre que uma mensagem chega em um ticket " +
      "vinculado à integração — em qualquer canal, conexão comum ou API " +
      "Oficial. A estrutura abaixo é o que o seu fluxo recebe; com ela, " +
      "você mesmo configura o lado do n8n.",
    tabs: [
      {
        id: "campos",
        label: "Campos",
        kind: "campos",
        header: "# Corpo (JSON) enviado ao seu webhook",
        lines: n8nCamposLines,
      },
      { id: "payload", label: "Payload", kind: "code", source: n8nPayloadExemplo },
      { id: "passos", label: "Configurar no n8n", kind: "code", source: n8nPassoAPasso },
    ],
  },
  {
    id: "typebot",
    label: "Typebot",
    method: "POST",
    endpoint: "{URL do Typebot}/api/v1/typebots/{slug}/startChat",
    intro:
      "Na integração Typebot, o PULSE consome a API do seu Typebot: abre a " +
      "sessão na primeira mensagem do contato e repassa as seguintes para o " +
      "fluxo, entregando as respostas do bot na conversa do WhatsApp.",
    tabs: [
      {
        id: "campos",
        label: "Campos",
        kind: "campos",
        header: "# Campos do cadastro da integração",
        lines: typebotCamposLines,
      },
      { id: "chamadas", label: "Chamadas", kind: "code", source: typebotChamadas },
      { id: "passos", label: "Configurar no Typebot", kind: "code", source: typebotPassoAPasso },
    ],
  },
  {
    id: "dialogflow",
    label: "DialogFlow",
    method: "API",
    endpoint: "Google Dialogflow ES (conta de serviço)",
    intro:
      "Na integração DialogFlow, cada mensagem do cliente é enviada ao agente " +
      "do Google Dialogflow ES e as respostas de intenção voltam para a " +
      "conversa. A autenticação usa uma conta de serviço do Google Cloud.",
    tabs: [
      {
        id: "campos",
        label: "Campos",
        kind: "campos",
        header: "# Campos do cadastro da integração",
        lines: dialogflowCamposLines,
      },
      { id: "passos", label: "Configurar no Dialogflow", kind: "code", source: dialogflowPassoAPasso },
    ],
  },
  {
    id: "flowbuilder",
    label: "Flowbuilder",
    method: "INTERNO",
    endpoint: "Fluxo criado no próprio PULSE",
    intro:
      "O Flowbuilder é o construtor de fluxos do próprio PULSE: a integração " +
      "apenas liga um fluxo já criado à conexão ou fila. Não há nada para " +
      "configurar fora do sistema.",
    tabs: [
      { id: "como", label: "Como funciona", kind: "code", source: flowbuilderComoFunciona },
    ],
  },
  {
    id: "sgp",
    label: "SGP",
    method: "POST",
    endpoint: "{SGP URL}/api/central/…",
    intro:
      "A integração SGP monta um autoatendimento para provedores: identifica " +
      "o assinante por CPF/CNPJ na central do SGP e executa a operação " +
      "definida na fila (segunda via de fatura ou liberação em confiança).",
    tabs: [
      {
        id: "campos",
        label: "Campos",
        kind: "campos",
        header: "# Campos do cadastro da integração",
        lines: sgpCamposLines,
      },
      { id: "como", label: "Como funciona", kind: "code", source: sgpComoFunciona },
    ],
  },
];

export default INTEGRATION_DOCS;
